import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

const sensorTypesSlice = createSlice({
  name: "sensorTypes",
  initialState,
  reducers: {
    fetchSensorTypesStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    fetchSensorTypesSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    fetchSensorTypesFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    resetSensorTypesState(state) {
      state.data = [];
      state.isLoading = false;
      state.error = null;
    },
  },
});

export const {
  fetchSensorTypesStart,
  fetchSensorTypesSuccess,
  fetchSensorTypesFailure,
  resetSensorTypesState,
} = sensorTypesSlice.actions;
export default sensorTypesSlice.reducer;
